// extracted by mini-css-extract-plugin
export default {"Box":"TimelineDivider-module__Box--rX5hB","Box_1":"TimelineDivider-module__Box_1--nXo59","Box_2":"TimelineDivider-module__Box_2--lsm39"};